import type { Theme } from '@ori-ui/mui';

export const createMarginWithImportant = (theme: Theme, spacing: number): string =>
  `${theme.spacing(spacing)} !important`;
